import React from 'react';

import { Layout, Typography } from 'antd';

import CabinetHeader from '../../../../components/Header';

const { Content } = Layout;
const { Title } = Typography;

const CommunityPage = () => (
  <Layout className="community-page under-development-page">
    <CabinetHeader />
    <Content>
      <Title>Раздел в разработке</Title>
    </Content>
  </Layout>
);

export default CommunityPage;
